import React from "react";
import { CardCustom } from "./styles";
import { Col, Row, Tabs } from "antd";
import { useSelector } from "react-redux";
import { BankConciliationProvider } from "../../../../contexts/bankConciliationContext";
import useBankConciliationContext from "../../../../hooks/useBankConciliationContext";
import Statement from "./tabs/statement";
import Conciliation from "./tabs/conciliation";
import { ConciliationProvider } from "../../../../contexts/conciliationContext";

// import { Container } from './styles';

function BankConciliationLayout() {
  const { tabSelected, handleTabClick } = useBankConciliationContext();
  const { translation } = useSelector((state) => state.app);

  return (
    <Row type="flex">
      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
        <Tabs
          type="card"
          defaultActiveKey="0"
          activeKey={tabSelected}
          onTabClick={handleTabClick}
        >
          <Tabs.TabPane
            tab={<span>{translation.bankConciliation.tabs.bankStatement}</span>}
            key="0"
          >
            <Statement />
          </Tabs.TabPane>
          <Tabs.TabPane
            tab={
              <span>{translation.bankConciliation.tabs.bankConciliation}</span>
            }
            key="1"
          >
            <Conciliation />
          </Tabs.TabPane>
        </Tabs>
      </Col>
    </Row>
  );
}

const BankConciliation = () => {
  return (
    <BankConciliationProvider>
      <ConciliationProvider>
        <BankConciliationLayout />
      </ConciliationProvider>
    </BankConciliationProvider>
  );
};

export default BankConciliation;
